const PROD_API_URL = 'https://kvt-sai-app-ms-prod-ekdnbvfyaaatang7.centralindia-01.azurewebsites.net/api';
const DEV_API_URL = 'https://kvt-sai-app-ms-akfbewfpf7bkggap.centralindia-01.azurewebsites.net/api';

const PROD_HOSTNAMES = [
  'kvt-sai-web-ms-prod-fye2afb3c6gcfxfr.centralindia-01.azurewebsites.net',
  'saisruthi.ssssoindia.org',
  'saishruthi.vercel.app'
];

// Use production API if the hostname matches one of the production domains.
// Otherwise, use the development API for localhost and dev deployments.
const isProduction = PROD_HOSTNAMES.includes(window.location.hostname);

export const API_BASE_URL = isProduction ? PROD_API_URL : DEV_API_URL;